import { ErrorNotification, SuccessNotification } from "./Notification"

export const PAGE_SIZE = 10

export const mapPotentialMember = (u) => ({
  value: u.id,
  label:
    u.name ||
    `${u.firstname || ""} ${u.lastname || ""}`.trim() ||
    u.email ||
    `Member ${u.id}`,
  member_type: u.member_type,
  member_id: u.id,
})

export const getMemberTypeForApi = (groupType) =>
  groupType === "farmers" ? "farmer" : "user"

export const formatApiError = (error) => {
  if (!error) return "An error occurred"
  if (typeof error === "string") return error
  if (Array.isArray(error)) return error.join(", ")

  if (typeof error === "object") {
    const messages = []
    Object.entries(error).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach((msg) =>
          messages.push(key === "non_field_errors" ? msg : `${key}: ${msg}`)
        )
      } else if (typeof val === "string") {
        messages.push(key === "non_field_errors" ? val : `${key}: ${val}`)
      }
    })
    return messages.join(", ") || "An error occurred"
  }

  return String(error)
}

export const getExistingMemberIds = (members = []) =>
  new Set(
    members
      .map((m) => m.member_details?.id ?? m.id ?? m.member_id)
      .filter(Boolean)
  )

/**
 * Shows the correct toast(s) for a bulk_add_members API response.
 * Never shows success when all additions failed.
 */
export const handleBulkAddMembersResponse = (data, { onSuccess, onClose }) => {
  const successful = data?.results?.successful || []
  const failed = data?.results?.failed || []
  const alreadyMembers = data?.results?.already_members || []
  const successfulCount = successful.length
  const failedCount = failed.length
  const alreadyCount = alreadyMembers.length
  const summaryIndicatesFailure =
    typeof data?.message === "string" && /,\s*\d+\s+failed/i.test(data.message)

  if (failedCount > 0 || (summaryIndicatesFailure && successfulCount === 0)) {
    const errorMessages = failed
      .map((item) => formatApiError(item?.error))
      .filter(Boolean)
      .join("; ")

    ErrorNotification(
      errorMessages ||
        (summaryIndicatesFailure ? data.message : "Failed to add members")
    )

    if (successfulCount > 0) {
      SuccessNotification(`Successfully added ${successfulCount} member(s)`)
      onSuccess?.()
    }

    return { ok: successfulCount > 0, shouldClose: successfulCount > 0 && failedCount === 0 }
  }

  if (successfulCount > 0) {
    SuccessNotification(`Successfully added ${successfulCount} member(s)`)
    onSuccess?.()
    onClose?.()
    return { ok: true, shouldClose: true }
  }

  if (alreadyCount > 0) {
    ErrorNotification("Selected member(s) are already in this group")
    return { ok: false, shouldClose: false }
  }

  ErrorNotification(data?.message || "No members were added. Please check your selection.")
  return { ok: false, shouldClose: false }
}
